import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { useState } from "react";

const PhoneTextField = ({
  value,
  onChange,
  label = "Số điện thoại",
  name = "phone",
  required = false,
  disabled = false,
}) => {
  const id = `${name}-input`;

  const [isFocused, setIsFocused] = useState(false);
  const hasError = required && value.trim() === "";

  const borderColor = hasError ? "#d63939" : isFocused ? "#206bc4" : "var(--tblr-border-color, #dadcde)";

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <label
        htmlFor={id}
        style={{
          position: "absolute",
          top: "-9px",
          left: "12px",
          background: "var(--tblr-bg-surface, #fff)",
          padding: "0 4px",
          fontSize: "12px",
          color: hasError ? "#d63939" : isFocused ? "#206bc4" : "var(--tblr-secondary, #626976)",
          pointerEvents: "none",
          zIndex: 1,
        }}
      >
        {label}
        {required && " *"}
      </label>
      <PhoneInput
        country="vn"
        value={value}
        onChange={(phoneValue, countryData) => {
          onChange(phoneValue, countryData);
        }}
        placeholder=" "
        inputProps={{
          name,
          id,
          disabled,
          onFocus: () => setIsFocused(true),
          onBlur: () => setIsFocused(false),
        }}
        containerStyle={{
          width: "100%",
        }}
        inputStyle={{
          width: "100%",
          height: "44px",
          paddingLeft: "48px",
          fontSize: "0.9375rem",
          border: `1px solid ${borderColor}`,
          borderRadius: "4px",
          backgroundColor: disabled ? "var(--tblr-bg-surface-secondary, #f5f5f5)" : "var(--tblr-bg-surface, #fff)",
          transition: "border-color 0.15s ease-in-out",
        }}
        buttonStyle={{
          border: "none",
          backgroundColor: "transparent",
        }}
      />
    </div>
  );
};

export default PhoneTextField;
